import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteBank } from '../../../../actions';

const BankDeleteButton = ({ dispatchDeleteBank, bankId, disabled }) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteBank({ bankId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

BankDeleteButton.propTypes = {
  dispatchDeleteBank: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  bankId: PropTypes.number.isRequired,
};

BankDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteBank: deleteBank,
};

export default connect(null, mapDispatchToProps)(BankDeleteButton);
